import { Layout as RALayout } from 'react-admin';
import { Menu } from './Menu';

export const Layout = (props: any) => <RALayout {...props} menu={Menu} sx={{
    backgroundColor: theme =>
        (theme.vars || theme).palette.background.default,
}}/>;
